export default __webpack_public_path__ + "static/media/16scissors.6e2145e4.jpg";